import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[klNumberInput]",
})
export class KlNumberInputDirective {
  numberArray = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  currentLanguage = sessionStorage.getItem("currentLanguage");
  @Input() maxLength: number;
  @Input() maxValue: number;

  constructor(private el: ElementRef) {
    el.nativeElement.autocomplete = "off";
  }

  @HostListener("keypress", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    const code = event.charCode
      ? event.charCode
      : event.which
      ? event.which
      : event.keyCode;
    this.el.nativeElement.maxLength = this.maxLength;
    if (code < 48 || code > 57) {
      if (
        code === 8 ||
        code === 46 ||
        code === 9 ||
        (code > 1775 && code < 1786)
      ) {
      } else {
        event.preventDefault();
      }
    } else {
      const target: any = event.target;
      if (this.maxValue) {
        if (parseInt(target.value + event.key) > Number(this.maxValue)) {
          event.preventDefault();
        }
      }
    }
  }

  @HostListener("paste", ["$event"])
  onPaste(event: any) {
    event.preventDefault();
    // const target = event.target;
    // target.maxLength = 100;
    // setTimeout(() => {
    //   let finallyValue = '';
    //   for (let i = 0; i < target.value.length; i++) {
    //     const validNumber = this.numberArray.find(result => target.value[i] === result);
    //     if (validNumber) {
    //       if (finallyValue.length < this.maxLength) {
    //         finallyValue += target.value[i];
    //       }
    //     }
    //   }
    //   if (this.maxValue) {
    //     if ((toInt(finallyValue)) <= toInt(this.maxValue)) {
    //       event.target.value = finallyValue;
    //     } else {
    //       event.target.value = '';
    //     }
    //   } else {
    //     event.target.value = finallyValue;
    //   }
    //   event.target.maxLength = this.maxLength;
    // }, 10);
  }
}
